export default function accessCssVariable(element, cssVariable) {
	if (!element[0]) {
		return '';
	}

	const cssVar = window
		.getComputedStyle(element[0])
		.getPropertyValue(cssVariable)
		.trim();
	return cssVar;
}
